import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  margin: 16px 0;
  padding: 16px 24px;
  background: #fff0e8;
  border: 1px solid #ff6720;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
  color: #000000;
`;

export const CompactCard = styled.div<{ $success?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 16px;
  padding: 10px 16px;
  background: ${({ $success }) => ($success ? "#F0F9EC" : "#fff0e8")};
  border: 1px solid ${({ $success }) => ($success ? "#67C940" : "#ff6720")};
  border-radius: 8px;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;

  svg {
    flex-shrink: 0;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Message = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

export const Track = styled.div`
  width: 100%;
  height: 19px;
  background: #ffffff;
  border-radius: 5px;
  overflow: hidden;
`;

export const Fill = styled.div`
  height: 100%;
  background: #f09252;
  border-radius: 5px;
`;

export const Footer = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 200;
`;

export const Strong = styled.span`
  font-weight: 500;
`;

export const Bold = styled.span`
  font-weight: 700;
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const LinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`;

export const HomeContainer = styled.div`
  margin: 0 0 24px;

  & > div {
    margin: 0;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin: 0 16px 12px;
  }
`;

export const BarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  & > :first-child {
    flex: 1 1 auto;
    min-width: 0;
  }

  & > :last-child {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    & > :last-child {
      white-space: normal;
    }

    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;
